/* Panda Food 2.0, Buy 2 Get 1 Free tracker.

   Reads the real cart. Only lines whose product is in the discount's own
   collection count, so the meter cannot promise something checkout will not
   honour.

   Slots grow a tier at a time: with three in the basket the next three appear,
   so there is always somewhere for the next pack to go.                       */
(function () {
  var root = document.querySelector('[data-pf2-tracker]');
  if (!root) return;

  var TIER = parseInt(root.dataset.tier, 10) || 3;
  var MAX = TIER * 3;
  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-pf2-scope]').textContent) } catch (e) { cfg = { ids: [] } }
  var SCOPE = {};
  (cfg.ids || []).forEach(function (id) { SCOPE[id] = 1 });

  var slots = root.querySelector('[data-pf2-slots]');
  var bar = root.querySelector('[data-pf2-bar]');
  var msg = root.querySelector('[data-pf2-msg]');
  var saved = root.querySelector('[data-pf2-saved]');
  var cta = root.querySelector('[data-pf2-cta]');

  function money(p) { return (function(v){var c=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'GBP';try{return new Intl.NumberFormat(c==='GBP'?'en-GB':'en-US',{style:'currency',currency:c}).format(v)}catch(e){return (c==='USD'?'$':c==='GBP'?'£':c+' ')+v.toFixed(2)}})(p/100) }
  function esc(t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function slotsShown(n) {
    var groups = Math.max(1, Math.floor(n / TIER) + (n % TIER === 0 ? 0 : 1));
    return Math.min(MAX, groups * TIER);
  }

  function render(cart) {
    /* one entry per qualifying UNIT, carrying its own price so the cheapest
       can be marked free, exactly as the discount allocates it */
    var units = [];
    (cart.items || []).forEach(function (l) {
      if (!SCOPE[l.product_id]) return;
      for (var i = 0; i < (l.quantity || 0); i++) {
        units.push({
          url: l.url ? l.url.split('?')[0] : '',
          img: l.image ? l.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') : '',
          name: l.product_title || l.title || '',
          price: l.original_price != null ? l.original_price : l.price
        });
      }
    });

    var n = units.length;
    var shown = slotsShown(n);
    var filled = Math.min(n, shown);
    var free = Math.floor(n / TIER);
    var needed = n === 0 ? TIER : (n % TIER === 0 ? 0 : TIER - (n % TIER));

    /* cheapest-is-free, one per completed tier */
    var order = units.map(function (u, i) { return { i: i, p: u.price } })
                     .sort(function (a, b) { return a.p - b.p });
    var freeSet = {}, savedTotal = 0;
    order.slice(0, free).forEach(function (x) { freeSet[x.i] = 1; savedTotal += x.p });

    var html = '';
    for (var i = 0; i < shown; i++) {
      var on = i < filled;
      var freeSlot = ((i + 1) % TIER === 0);
      if (on) {
        var u = units[i];
        html += '<a class="pf2-b21-slot on" href="' + esc(u.url) + '" title="' + esc(u.name) + '">' +
                (freeSet[i] ? '<span class="tag">Free</span>' : '') +
                '<img src="' + esc(u.img) + '" alt="' + esc(u.name) + '">' +
                '</a>';
      } else {
        html += '<a class="pf2-b21-slot" href="' + esc(root.dataset.shopUrl) + '">' +
                (freeSlot ? '<span class="tag">Free</span>' : '') +
                '<span class="n">' + (i + 1) + '</span>' +
                '<span class="cap">' + (freeSlot ? 'your free pack' : 'add a pack') + '</span>' +
                '</a>';
      }
    }
    slots.innerHTML = html;

    if (bar) bar.style.width = (shown ? Math.min(100, filled / shown * 100) : 0) + '%';

    if (n === 0) msg.textContent = 'Add ' + TIER + ' packs and the cheapest is free.';
    else if (needed === 0) msg.textContent = free > 1 ? (free + ' free packs unlocked!') : 'Free pack unlocked!';
    else if (needed === 1) msg.textContent = 'Add 1 more to unlock a free pack.';
    else msg.textContent = 'Add ' + needed + ' more to unlock a free pack.';
    root.classList.toggle('is-done', n > 0 && needed === 0);

    if (saved) {
      if (savedTotal > 0) { saved.hidden = false; saved.textContent = 'You have saved ' + money(savedTotal) + ' so far.' }
      else saved.hidden = true;
    }

    /* a complete tier means the next useful step is the basket, not more browsing */
    if (cta) {
      var done = n > 0 && needed === 0;
      cta.textContent = done ? (cfg.checkout || 'Go to basket') : (cfg.browse || 'Browse all socks');
      cta.setAttribute('href', done ? root.dataset.cartUrl : root.dataset.shopUrl);
    }
  }

  function load() {
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) { return r.json() })
      .then(render)
      .catch(function () { render({ items: [] }) });
  }

  /* the buy box tells us when it has changed the cart, so no polling */
  document.addEventListener('pf2:cart:updated', function (e) { render(e.detail) });
  load();
})();
